<script setup>
</script>

<template>
	<nav>
		<a href="/"><img class="zev"><div>Home</div></a>
		<RouterLink :to="{ name: 'map' }"><img class="map"><div>Map</div></RouterLink>
		<RouterLink :to="{ name: 'sites' }"><img class="sites"><div>Sites</div></RouterLink>
	</nav>
	<RouterView class="view"/>
</template>
